/** East Africa ISO markets for super-admin filters (plans, companies, analytics). */
export const ADMIN_MARKET_COUNTRIES = [
  { code: "RW", label: "Rwanda", currency: "RWF" },
  { code: "KE", label: "Kenya", currency: "KES" },
  { code: "UG", label: "Uganda", currency: "UGX" },
  { code: "TZ", label: "Tanzania", currency: "TZS" },
] as const;

export type AdminMarketCountryCode =
  (typeof ADMIN_MARKET_COUNTRIES)[number]["code"];

export function labelForAdminCountry(countryCode: string): string {
  if (countryCode === "OTHER") return "Other / unknown";
  return (
    ADMIN_MARKET_COUNTRIES.find((c) => c.code === countryCode)?.label ??
    countryCode
  );
}

export function currencyForAdminCountry(countryCode: string): string {
  if (countryCode === "OTHER") return "RWF";
  return (
    ADMIN_MARKET_COUNTRIES.find((c) => c.code === countryCode)?.currency ??
    "RWF"
  );
}

/** Normalize currency codes from analytics for display */
export function formatCurrencyCode(currency: string): string {
  if (!currency || currency === "OTHER") return "RWF";
  return currency;
}

export function formatAdminMoney(
  amount: number | null | undefined,
  currency = "RWF",
): string {
  if (amount == null || Number.isNaN(amount)) return "—";
  return `${new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)} ${currency}`;
}

/** e.g. "RWF 3,520 · KES 1,200" */
export function formatRevenueByCurrency(
  rows: { currency: string; amount: number }[],
): string {
  if (rows.length === 0) return "—";
  return rows
    .filter((r) => r.amount > 0)
    .map((r) => formatAdminMoney(r.amount, formatCurrencyCode(r.currency)))
    .join(" · ");
}
